import { NexsysOrder } from '../model/nexsys-monitor-state.model';
import { NexsysOrderListFilters } from '../model/nexsys-monitor-state.model';

export class SetNexsysOrderLogInfo {
	static readonly type = '[NexsysOrderLogs] SetNexsysOrderLogInfo';

	constructor(public nexsysOrderLog: NexsysOrder) {}
}

export class SetNexsysOrderListFilters {
	static readonly type = '[NexsysOrder] SetNexsysOrderListFilters';

	constructor(public nexsysOrderListFilters: NexsysOrderListFilters) {}
}

export class SetOrderMonitorOrigin {
	static readonly type = '[NexsysOrder] SetOrderMonitorOrigin';

	constructor(public origin: string) {}
}
